import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPropertiesByOrganizationIdQueryVariables = Types.Exact<{
  organization_id: Types.Scalars['uuid']['input'];
}>;


export type GetPropertiesByOrganizationIdQuery = { __typename?: 'query_root', properties: Array<{ __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, premium?: boolean | null, tier_status?: string | null, workspace_id?: any | null, photo_link?: string | null, organization_id: any, warranty_expiration_date?: any | null, warranty_start_date?: any | null, warranty_document_id?: any | null, building_type?: string | null, expected_device_type?: any | null, created_at?: any | null, updated_at?: any | null, partition_id?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, contact_name?: string | null, email?: string | null, type?: string | null } | null, property_contacts: Array<{ __typename?: 'property_contacts', id: any, name?: string | null, number?: string | null, email?: string | null }> }> };


export const GetPropertiesByOrganizationIdDocument = gql`
    query getPropertiesByOrganizationId($organization_id: uuid!) {
  properties(
    where: {organization_id: {_eq: $organization_id}}
    order_by: {name: asc}
  ) {
    id
    name
    address
    address_id
    standardized_address {
      id
      street_1
      street_2
      city
      state
      postal_code
      country
    }
    premium
    tier_status
    workspace_id
    photo_link
    organization_id
    warranty_expiration_date
    warranty_start_date
    warranty_document_id
    building_type
    expected_device_type
    created_at
    updated_at
    partition_id
    organization_id
    organization {
      id
      name
      contact_name
      email
      type
    }
    property_contacts {
      id
      name
      number
      email
    }
  }
}
    `;

/**
 * __useGetPropertiesByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetPropertiesByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesByOrganizationIdQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetPropertiesByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<GetPropertiesByOrganizationIdQuery, GetPropertiesByOrganizationIdQueryVariables> & ({ variables: GetPropertiesByOrganizationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertiesByOrganizationIdQuery, GetPropertiesByOrganizationIdQueryVariables>(GetPropertiesByOrganizationIdDocument, options);
      }
export function useGetPropertiesByOrganizationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertiesByOrganizationIdQuery, GetPropertiesByOrganizationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertiesByOrganizationIdQuery, GetPropertiesByOrganizationIdQueryVariables>(GetPropertiesByOrganizationIdDocument, options);
        }
export function useGetPropertiesByOrganizationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertiesByOrganizationIdQuery, GetPropertiesByOrganizationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertiesByOrganizationIdQuery, GetPropertiesByOrganizationIdQueryVariables>(GetPropertiesByOrganizationIdDocument, options);
        }
export type GetPropertiesByOrganizationIdQueryHookResult = ReturnType<typeof useGetPropertiesByOrganizationIdQuery>;
export type GetPropertiesByOrganizationIdLazyQueryHookResult = ReturnType<typeof useGetPropertiesByOrganizationIdLazyQuery>;
export type GetPropertiesByOrganizationIdSuspenseQueryHookResult = ReturnType<typeof useGetPropertiesByOrganizationIdSuspenseQuery>;
export type GetPropertiesByOrganizationIdQueryResult = Apollo.QueryResult<GetPropertiesByOrganizationIdQuery, GetPropertiesByOrganizationIdQueryVariables>;